'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var Video = _interopDefault(require('./video.js'));

var BackgroundVideo = function (_Video) {
  _inherits(BackgroundVideo, _Video);

  /**
   * Extends from ui_video and initiates ui (play/pause button)
   * @param {DOM} el Element wrapper for video and play/pause button
   * @param {Object} [options] configuration options
   * @class BackgroundVideo
   * @constructor
  */

  function BackgroundVideo(el, options) {
    _classCallCheck(this, BackgroundVideo);

    var video = el ? el.querySelector('video') : null;

    var _this = _possibleConstructorReturn(this, (BackgroundVideo.__proto__ || _Object$getPrototypeOf(BackgroundVideo)).call(this, video, options));

    if (!el) {
      return _possibleConstructorReturn(_this);
    }
    el.querySelector('.background-video-next__button').addEventListener('click', _this.onPlayPause.bind(video));
    return _this;
  }

  /**
   * Method that toggles play/pause button and controls playback.
   * @method onPlayPause
   * @param {event} evt an event ('click' in this case) that helps the ui find the corresponding video to target
  */

  _createClass(BackgroundVideo, [{
    key: 'onPlayPause',
    value: function onPlayPause(evt) {
      var videoButton = evt.target;
      videoButton.classList.toggle('background-video-next__button--play');

      if (this.paused || this.ended) {
        // eslint-disable-next-line promise/valid-params
        this.play().then(videoButton.setAttribute('aria-label', 'pause')).catch();
      } else {
        this.pause();
        videoButton.setAttribute('aria-label', 'play');
      }

      var videoButtonPressed = videoButton.getAttribute('aria-pressed') === 'true';
      videoButton.setAttribute('aria-pressed', !videoButtonPressed);
    }
  }, {
    key: 'initFallback',
    value: function initFallback() {
      var video = this.$video.get(0);
      var videoWrapper = video.parentNode;
      var img = new Image();
      var imgClasses = ['js-is-active'].concat(video.className.split(/\s+/));

      img.setAttribute('src', video.getAttribute('data-poster'));
      img.setAttribute('alt', '');
      img.className = imgClasses.join(' ');
      videoWrapper.appendChild(img);
      videoWrapper.querySelector('button').classList.add('hide--mobile');
      videoWrapper.removeChild(video);
    }
  }]);

  return BackgroundVideo;
}(Video);

module.exports = BackgroundVideo;
